import {
  RENT_VEHICLE_LIST,
  RENT_VEHICLE_DELETE,
  BOOKED_RENT_VEHICLE_LIST,
  RENTALS_ORDERS_DETAILS,
  LOADING,
  NOT_FOUND,
  ADD_NOTES,
} from "./type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

export const ManageRentVehicleList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/rentVehicle`, config);
    dispatch({
      type: RENT_VEHICLE_LIST,
      payload: res.data,
    });
    if (res.data?.data?.rentVehicle?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const ManageBookedRentVehicleList = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${APIURL}/api/v1/rentVehicle/getbysatus`,
      config
    );
    dispatch({
      type: BOOKED_RENT_VEHICLE_LIST,
      payload: res.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const viewOrdersRentalDetails = (id) => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/rentVehicle/${id}`, config);
    dispatch({
      type: RENTALS_ORDERS_DETAILS,
      payload: res?.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const deleteRentVehicle = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete vehicle?")) {
      const res = await axios.delete(
        `${APIURL}/api/v1/rentVehicle/${id}`,
        config
      );
      dispatch({
        type: RENT_VEHICLE_DELETE,
        payload: res.data,
      });
      toast.success("Vehicle Deleted Successfully!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const deleteMultiRentVehicle = (ids) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const label = ids?.length > 1 ? "Vehicles" : "Vehicle";
  try {
    if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`)) {
      const res = await axios.delete(
        `${APIURL}/api/v1/rentVehicle/delete/${ids}`,
        config
      );
      dispatch({
        type: RENT_VEHICLE_DELETE,
        payload: res.data,
      });
      toast.success(`${label} Deleted Successfully!`);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const addNoteToRentOrder = (payload, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  let data = JSON.stringify({
    note: payload?.notes,
    rentVehicleId: payload.rentVehicleId,
  });
  try {
    const response = await axios.post(`${APIURL}/api/v1/rentVehicle/notes`, data, config);
    callBack("success");
    dispatch({ type: ADD_NOTES, payload: response?.data });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};